<template>
<header class="dx-topbar">
    <div class="dx-topbar--left-wrapper">
      <div class="dx-topbar--logo" @click="goToDashboard()" @keyDown="goToDashboard()">
        <img class="dx-logo" alt="logo" src="@assets/images/logo_docx.png"/>
      </div>
    </div>
    <nav class="dx-topbar--nav">
      <dx-navbar @logoutAction="logoutAction" :firstName="firstName" :is-admin="isAdmin">
      </dx-navbar>
    </nav>
</header>
</template>

<script>

export default {
  name: 'dx-topbar',
  emits: ['logoutAction'],
  props: {
    username: String,
    isAdmin: Boolean,
  },
  computed: {
    firstName() {
      return this.username?.split(' ')[0];
    },
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: 'Dashboard' });
    },
    logoutAction() {
      this.$emit('logoutAction');
    },
  },
};
</script>

<style scoped lang="scss">
.dx-topbar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 0;
  height: var(--dx-topbar--height);
  width: 100vw;
  background-color: var(--dx-color--blue-semi-light);
  z-index: var(--dx-zindex-header-fixed);
}

.dx-topbar--left-wrapper {
  display: flex;
  align-items: center;
  min-width: 0;
}

.dx-topbar--logo {
  cursor: pointer;
  line-height: 0;
}

.dx-logo {
  display: inline-block;
  width: 174px;
  height: 24px;
  margin-left: 4px;
  margin-bottom: 3px;
}

.dx-topbar--nav {
  display: flex;
  align-items: stretch;
}
</style>
